import { NAME } from './constants';
import { router } from './router';
import { apiProvider } from './api';

export const AccountReceivable = {
	name: NAME,
	router,
	apiProvider,
};
